import { Checkbox, Inline, Notice, Stack, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { useMemo } from 'react';
import { getSecondBagPrice } from '../utils/secondBagUtils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const secondBagLabelStyle = css`
  flex-grow: 1;
  text-align: start;

  [dir='rtl'] & {
    text-align: end;
  }
`;
const SecondBagCheckBox = _ref => {
  var _orderSecondBag$bound, _orderSecondBag$bound2, _orderSecondBag$sellS, _orderSecondBag$sellS2;
  let {
    abstract,
    isSelectedSecondBaggage,
    onChange,
    secondBagTraveler,
    orderSecondBag
  } = _ref;
  const {
    t
  } = useTranslation();
  const numberOfBounds = (_orderSecondBag$bound = (_orderSecondBag$bound2 = orderSecondBag.bounds) === null || _orderSecondBag$bound2 === void 0 ? void 0 : _orderSecondBag$bound2.length) !== null && _orderSecondBag$bound !== void 0 ? _orderSecondBag$bound : 0;
  const shouldShowPricePerBoundSecondBag = orderSecondBag === null || orderSecondBag === void 0 ? void 0 : orderSecondBag.shouldShowPricePerBound;
  const secondBagPrice = useMemo(() => getSecondBagPrice(shouldShowPricePerBoundSecondBag, numberOfBounds, secondBagTraveler), [shouldShowPricePerBoundSecondBag, numberOfBounds, secondBagTraveler]);
  const {
    options = []
  } = (_orderSecondBag$sellS = (_orderSecondBag$sellS2 = orderSecondBag.sellSpecification.sellPriceBaggage) === null || _orderSecondBag$sellS2 === void 0 ? void 0 : _orderSecondBag$sellS2[0]) !== null && _orderSecondBag$sellS !== void 0 ? _orderSecondBag$sellS : {};
  const {
    weight: weightOfSecondBag,
    weightUnit: weightUnitOfSecondBag
  } = options[0] || {};
  const secondBagPricePerBoundLabel = shouldShowPricePerBoundSecondBag && numberOfBounds > 1 ? t('Products.Price.Label.PerBounds').replace('{0}', `<strong>${secondBagPrice}</strong>`) : undefined;
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsx(Text, {
      "data-testid": "secondbag-question",
      children: t('Product.SecondBag.Question.Label')
    }), /*#__PURE__*/_jsxs(Inline, {
      alignY: "center",
      spacing: 8,
      children: [/*#__PURE__*/_jsx(Checkbox, {
        checked: isSelectedSecondBaggage,
        "data-offer-rate": orderSecondBag.id,
        "data-testid": "checkbox-secondbag",
        id: "secondBaggage-checkbox",
        name: "PURCHASABLE_SECONDBAG",
        onChange: event => onChange(event.target.checked)
      }), /*#__PURE__*/_jsx(Text, {
        as: "bdi",
        className: secondBagLabelStyle,
        "data-testid": "secondbag-allowance",
        children: t('Product.SecondBag.Option.Label', weightOfSecondBag, weightUnitOfSecondBag)
      }), secondBagPricePerBoundLabel ? /*#__PURE__*/_jsx(Text, {
        asHtml: true,
        "data-testid": `toggleChoice-${secondBagTraveler === null || secondBagTraveler === void 0 ? void 0 : secondBagTraveler.id}-price-per-bound`,
        children: secondBagPricePerBoundLabel
      }) : /*#__PURE__*/_jsx(Text, {
        "data-testid": `toggleChoice-${secondBagTraveler === null || secondBagTraveler === void 0 ? void 0 : secondBagTraveler.id}-price`,
        variant: "16-bold",
        children: secondBagPrice
      })]
    }), abstract && /*#__PURE__*/_jsx(Notice, {
      "data-testid": "abstract-secondbag",
      variant: "promotional",
      children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
        content: abstract
      })
    })]
  });
};
export default SecondBagCheckBox;
//# sourceMappingURL=SecondBagCheckBox.js.map